import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";

// Inicia Sentry o mais cedo possível pra capturar erros de boot.
// Só ativa se VITE_SENTRY_DSN estiver setado no env (Vercel/prod).
initSentry();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
